<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <memberList></memberList>
    </Content>
  </Layout>
</template>
<script>
import memberList from './components/memberList'
export default {
  name: 'applicationDefault',
  components: { memberList },
  data() {
    return {}
  },
  methods: {},
  created() {}
}
</script>
<style lang="scss" scoped></style>
